//
//
//
//
//
//

export default {
name: "FilterState",
  props: {
    color: {
      type: String,
      default: '#212A4B'
    }
  }
}
